/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Lock_FailedInputs */

const cs_workflow_lock_failed = /** @type {(inputs: Workflow_Lock_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workflow se nepodařilo zamknout`)
};

const en_workflow_lock_failed = /** @type {(inputs: Workflow_Lock_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not lock the workflow`)
};

/**
* | output |
* | --- |
* | "Could not lock the workflow" |
*
* @param {Workflow_Lock_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_lock_failed = /** @type {((inputs?: Workflow_Lock_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Lock_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_lock_failed(inputs)
	return cs_workflow_lock_failed(inputs)
});